<template>
  <div>
    <header>
      <div class="top" v-if="path != 'error'">
        <img :src="info.face_logo" :onerror="errorImg" />
        <div class="class-info" style="width:1000px">
          <p class="title">
            {{ info.username }}
            <span>{{ info.userid }}</span>
          </p>
          <p class="contents">
            <span>{{ info.subjectName ? info.subjectName : "暂无科目" }}</span>
            <span @click="jumpPath(5)" :style="info.school_name ? 'cursor:pointer;' : ''">{{
                info.school_name && info.status == 1
                  ? info.school_name
                  : "暂无学校"
              }}</span>
          </p>
          <p class="contents p-1">
            <span class>{{ mood ? mood : "这家伙很懒，什么也没写..." }}</span>
          </p>
        </div>

        <div class="go_space">
          <el-button type="primary" @click="jumpTeacher(owner_id)" v-if="is_teach_researcher">教研员空间</el-button>
        </div>
      </div>
      <div class="top-column" v-if="path != 'error'">
        <router-link :class="path == 'home' ? 'active' : ''"
          :to="{ path: 'home', query: { userid: this.owner_id } }">主页</router-link>
        <router-link :class="path == 'photo_album' || path == 'photo_info' ? 'active' : ''"
          :to="{ path: 'photo_album', query: { userid: this.owner_id } }">相册</router-link>
        <router-link :class="path == 'teaching_acticle' ? 'active' : ''"
          :to="{ path: 'teaching_acticle', query: { userid: this.owner_id } }">备课中心</router-link>
        <router-link :class="path == 'theory' ? 'active' : ''"
          :to="{ path: 'theory', query: { userid: this.owner_id } }">理论研究</router-link>
        <router-link :class="path == 'group' ? 'active' : ''"
          :to="{ path: 'group', query: { userid: this.owner_id } }">专题工作</router-link>
        <router-link :class="path == 'collective_preparation' ? 'active' : ''" :to="{
            path: 'collective_preparation',
            query: { userid: this.owner_id },
          }">集体备课</router-link>
        <router-link :class="path == 'seminar' ? 'active' : ''"
          :to="{ path: 'seminar', query: { userid: this.owner_id } }">专题讨论</router-link>
        <router-link :class="path == 'new_education' ? 'active' : ''"
          :to="{ path: 'new_education', query: { userid: this.owner_id } }">新教育</router-link>
        <!-- <router-link :class="path == 'innovation_academic' ? 'active' : ''"
          :to="{ path: 'innovation_academic', query: { userid: this.owner_id } }" v-if="!is_kindergarten">教育教学创新</router-link> -->
        <router-link :class="
            path == 'weike' ||
            path == 'memoir' ||
            path == 'match' ||
            path == 'live'
              ? 'active'
              : ''
          " :to="{ path: 'weike', query: { userid: this.owner_id } }">我的视频</router-link>
        <router-link :class="path == 'my_class' ? 'active' : ''"
          :to="{ path: 'my_class', query: { userid: this.owner_id } }">我的班级</router-link>
        <router-link :class="path == 'statistics' ? 'active' : ''"
          :to="{ path: 'statistics', query: { userid: this.owner_id } }">资源统计</router-link>
      </div>
    </header>

    <el-dialog title="提示" :visible.sync="showMessage" width="25%" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <div class="showmessage">
        <p>请使用PC端或APP完善学校任教信息后，使用个人空间完整功能。</p>
        <p>
          请在下方输入框输入：
          <span style="color: red">{{ codeNum }}</span>
        </p>
        <el-input v-model="code"></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showMessageOK">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import globalApi from "../../common/globalApi.js";
export default {
  name: "Header",
  data() {
    return {
      errorImg:
        'this.src="' + require("../../assets/img/menu_mine_on@3x.png") + '"', // 图片损坏默认图
      identity: "", // 身份
      owner_id: "",
      showMessage: false,
      isLogin: false,
      username: "",
      userface: "",
      info: {},
      path: "", // 当前路由
      mood: "",
      today_visitor: 0,
      total_visitor: 0,
      userid: 1,
      codeNum: 0,
      code: "",
      userInfo: [],
      is_teach_researcher: false,
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
    };
  },

  components: {},

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    $route() {
      //监控$route
      document.documentElement.scrollTop = 0;
      this.owner_id = this.$route.query.userid;
      this.path = this.$route.path.replace(/\//g, "");
    },
    userInfo: function () {
      this.$nextTick(function () {
        this.getInfo();
      });
    },
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},
  methods: {
    init() {
      document.documentElement.scrollTop = 0;
      this.owner_id = this.$route.query.userid;
      this.path = this.$route.path.replace(/\//g, "");
      this.IsEduResearcher();
      if (this.path != "error") {
        this.getLoginInfo();
        this.getVisitor();
      }
      this.getMood();
    },
    //是否教研员
    async IsEduResearcher() {
      const userids = JSON.stringify([this.owner_id]);
      let data = {
        s: "WebEducationSpace.EduBureau.IsEduResearcher",
        edu_id: this.edu_id,
        user_id: userids,
      };
      let res = await globalApi.post(data);
      this.is_teach_researcher = res.data.data.list[0].is_researcher;
    },
    // 获取登录数据
    async getLoginInfo() {
      const isLogin = this.websiteSessionInfo.logined;
      this.isLogin = isLogin;
      if (isLogin) {
        this.username = this.websiteSessionInfo.userName;
        this.userface = this.websiteSessionInfo.userFace;
        this.userid = this.websiteSessionInfo.userid;
        this.GetIdentity(); // 获取登录身份
      } else {
        this.userid = 1;
      }
    },

    //获取教师签名
    async getMood() {
      let user_id_json = JSON.stringify([this.owner_id]);
      const data = {
        s: "WebSchoolSpace.Common.GetUserBaseInfo",
        user_id_json: user_id_json,
      };
      let res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.userInfo = res.data.data[0];

      this.mood = res.data.data[0].mood;
    },

    //获取访问统计
    async getVisitor() {
      const data = {
        s: "WebSchoolSpace.VisitorRecord.GetVisitorCount",
        id: this.owner_id,
        space_type: 1,
      };
      let res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      if (res.data.ret == 200 && res.data.data.result == 1) {
        this.today_visitor = res.data.data.today_count;
        this.total_visitor = res.data.data.total_count;
      } else {
        this.$router.push("/error");
        return false;
      }
    },

    //跳转教研员空间/老师
    async jumpTeacher(id) {
      window.open(
        globalApi.GetWebHost("researcher") + "home?userid=" + id,
        "_blank"
      );
    },

    //获取教师空间信息
    async getInfo() {
      const data = {
        s: "WebTeacherSpace.TeacherInfo.GetInfo",
        teacher_id: this.owner_id,
      };
      let res = await globalApi.post(data);

      if (res.data.ret == 200) {
        if (res.data.data.status == 0) {
          let teacherInfo = new Object();
          teacherInfo.username = this.userInfo.username;
          teacherInfo.school_name = this.userInfo.school_name;
          teacherInfo.userid = this.userInfo.userid;
          teacherInfo.face_logo = this.userInfo.user_face;
          teacherInfo.subjectName = "";
          this.info = teacherInfo;
          if (this.owner_id == this.userid) {
            this.showMessage = true;
            this.codeNum = Math.floor(Math.random() * 8999 + 1000);
          }
          return false;
        }
        this.info = res.data.data;
        if (this.info.status != 1 && this.owner_id == this.userid) {
          this.showMessage = true;
          this.codeNum = Math.floor(Math.random() * 8999 + 1000);
        }
      }
    },

    // 获取身份
    async GetIdentity() {
      const data = {
        s: "Common.Auth.getIdentity",
        user_id: this.userid, // 登陆者id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.identity = res.data.data;
    },
    // 跳转页面
    // 1 学校后台
    // 2 我的学校
    // 3 我的班级
    // 4 我的空间(教师/学生空间)
    // 5 当前教师空间的学校

    async jumpPath(val) {
      await globalApi.CheckLoginUserStatus();

      if (val == 5) {
        globalApi.jumpPath(5, "home", "schoolid=" + this.info.schoolid); // 当前空间的学校
        return false;
      }
      var identity = this.identity;
      var i = identity["isTeacher"] ? 8 : 7; //7-学生空间 8-教师空间
      if (val == 1) {
        globalApi.jumpPath(1, ""); // 学校后台
      } else if (val == 2) {
        globalApi.jumpPath(5, "home", "schoolid=" + identity.school_id); // 我的学校
      } else if (val == 3) {
        if (identity["isTeacher"]) {
          globalApi.jumpPath(i, "my_class", "userid=" + identity.user_id); // 如果是教师跳转到该教师空间的我的班级模块
        } else {
          globalApi.jumpPath(6, "home", "classid=" + identity.class_id); // 我的班级
        }
      } else if (val == 4) {
        globalApi.jumpPath(i, "home", "userid=" + identity.user_id); // 我的空间
      }
    },
    showMessageOK() {
      if (this.code == this.codeNum) {
        this.showMessage = false;
      } else {
        this.$message({
          message: "您的输入不正确，请重新输入！",
          type: "warning",
        });
      }
    },
  },
};
</script>
<style>
@import "../../assets/css/reset.css";
</style>
<style lang="scss">
header {
  color: #fff;
  a {
    color: #fff;
  }
  .topBarWrap {
    font-size: 14px;
    background: #0077b3;
    line-height: 40px;
    .topBar {
      background: #0077b3;
      width: 1200px;
      height: 40px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        margin-right: 20px;
        cursor: pointer;
      }
      .topBar_right {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-dropdown-item {
          a {
            color: #333 !important;
          }
        }
        img {
          height: 30px;
          width: 30px;
          border-radius: 50%;
          vertical-align: middle;
        }
        .el-dropdown-link {
          cursor: pointer;
          color: #fff;
        }
        .el-icon-arrow-down {
          font-size: 12px;
        }
        .item {
          margin-top: 10px;
          margin-right: 40px;
        }
      }
    }
  }
  .middleBarWrap {
    background: #00aaff;
    .middleBar {
      background: #00aaff;
      margin: 0 auto;
      width: 1200px;
      height: 120px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .middleBar_left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 50px;
        img {
          width: 84px;
          border-radius: 50%;
          display: inline;
        }
        h1 {
          font-weight: bold;
          font-size: 42px;
        }
      }
      .middleBar_right {
        .downloadBtn {
          display: inline-block;
          float: right;
          width: 194px;
          height: 40px;
          margin-top: 16px;
          background: url(../../assets/img/btn-appdownload.png) no-repeat center
            center;
        }
        .downloadBtn:hover {
          background: url(../../assets/img/btn-appdownload-h.png) no-repeat
            center center;
        }
      }
    }
  }

  .bottomBarWrap {
    .nav_active {
      background: #006dcc !important;
    }
    background: #0088ff;
    .bottomBar {
      margin: 0 auto;
      width: 1200px;
      height: 46px;
      font-size: 16px;
      .el-menu.el-menu--horizontal {
        border-bottom: none;
        color: #fff;
        height: 46px;
        .el-menu-item {
          height: 46px;
          line-height: 46px;
          color: #fff;
          font-size: 16px;
        }
        .el-submenu {
          .el-submenu__title {
            height: 46px !important;
            line-height: 46px !important;
            color: #fff;
            font-size: 16px;
            padding: 0;
          }
          .el-submenu__icon-arrow {
            display: none;
          }
        }
        .el-menu-item.is-active {
          border-bottom: none;
        }
      }
    }
  }
}

.el-menu--popup {
  min-width: 100px;
  padding: 0;
}
.el-menu--popup-bottom-start {
  margin-top: 0;
}
.el-menu--horizontal .el-menu .el-menu-item {
  background: #0088ff;
  color: #fff;
  height: 100%;
  font-size: 16px;
  padding: 0 20px;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: #007ae6;
  color: #fff;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #fff;
  background: #007ae6;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active {
  color: #fff;
}

.top {
  .go_space {
    position: absolute;
    left: 1000px;
    top: 100px;
  }
  .contents {
    span {
      margin-right: 20px;
    }
  }
  .p-1 {
    margin-top: 10px;
  }
  img {
    border: 1pt solid;
  }
}
</style>
<style scoped lang="scss">
@import "../../assets/css/reset.css";
</style>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.username {
  display: inline-block;
  margin: 0 10px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 5em;
}
.showmessage p {
  margin: 20px 0;
}
</style>
<style >
.el-loading-spinner {
  font-size: 50px;
  padding: 20px 0;
}
.el-loading-spinner .el-loading-text {
  font-size: 24px;
  color: white;
}
.el-loading-spinner i {
  color: white;
  margin-bottom: 20px;
}
.el-pagination {
  text-align: center;
  padding: 20px 0 0px 0;
}
.showmessage .el-input {
  width: 150px;
}
.msg {
  position: absolute;
  display: block;
  border-radius: 50%;
  background-color: #ff2122;
  color: #fff;
  font-size: 0.3rem;
  width: 0.6rem;
  height: 0.6rem;
  line-height: 0.4rem;

  top: 0.9rem;
  right: 0.6rem;
}
</style>